// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__cOnfx","header":"ReportDetails_header__1YBV_","title":"ReportDetails_title__3dulI","left":"ReportDetails_left__o0BJV"};